import { Download } from '@drift-labs/icons';
import PnlModalCopyButton from 'src/components/Modals/PnlModal/PnlModalButtons/PnlModalCopyButton';
import Button from 'src/components/primitives/Button/Button';
import usePostHogCapture from 'src/hooks/posthog/usePostHogCapture';
import { getIsAndroidWebView } from 'src/utils/browser';
import { cj } from 'src/utils/classNames';

interface Props {
	handleClose: () => void;
	handleDownload: () => void;
	handleCopy: () => void;
	className?: string;
	isDownloading: boolean;
	isCopying: boolean;
	isCopied: boolean;
}

export default function PnlModalButtons({
	className,
	handleClose,
	handleCopy,
	handleDownload,
	isDownloading,
	isCopying,
	isCopied,
}: Props) {
	const { captureEvent } = usePostHogCapture();

	const handleDownloadClick = () => {
		handleDownload();

		captureEvent('pnl_modal_action', { action: 'download' });
	};

	return (
		<div className={cj('flex items-center gap-x-md', className)}>
			{/* Android WebView doesn't support copying or downloading images. */}
			{/* So all we show for it is a close button. */}
			{getIsAndroidWebView() && (
				<Button
					size="lg"
					variant="secondary"
					className="flex-1"
					onClick={handleClose}
				>
					Close
				</Button>
			)}

			{!getIsAndroidWebView() && (
				<>
					<PnlModalCopyButton
						isCopying={isCopying}
						isCopied={isCopied}
						handleCopy={handleCopy}
					/>

					<Button
						size="lg"
						className="flex-1"
						onClick={handleDownloadClick}
						rightIcon={Download}
						isLoading={isDownloading}
					>
						Download
					</Button>
				</>
			)}
		</div>
	);
}
